import { useState } from 'react';
import emailjs from '@emailjs/browser';

// Helper function to subscribe to Mailchimp via JSONP
const subscribeToMailchimp = (email, fname, lname) => {
  return new Promise((resolve, reject) => {
    const url = `https://gonzalezinfo.us6.list-manage.com/subscribe/post?u=${import.meta.env.VITE_MAILCHIMP_U}&id=${import.meta.env.VITE_MAILCHIMP_ID}&EMAIL=${encodeURIComponent(email)}&MERGE1=${encodeURIComponent(fname)}&MERGE2=${encodeURIComponent(lname)}`;
    console.log('url', url);

    const callbackName = `mailchimpCallback_${Date.now()}`;

    window[callbackName] = (data) => {
      delete window[callbackName];
      document.body.removeChild(script);
      if (data.result === 'success') {
        resolve(data);
      } else {
        reject(new Error(data.msg || 'Subscription failed'));
      }
    };

    const script = document.createElement('script');
    script.src = `${url}&c=${callbackName}`;
    script.onerror = () => {
      delete window[callbackName];
      document.body.removeChild(script);
      reject(new Error('Failed to load Mailchimp script'));
    };
    document.body.appendChild(script);
  });
};

function Contact() {
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [subscribe, setSubscribe] = useState(false);
  const [status, setStatus] = useState('idle'); // idle | sending | success | error
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    setErrorMessage('');

    try {
      // Send contact form email
      await emailjs.send(
        import.meta.env.VITE_EMAILJS_SERVICE_ID,
        import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
        { fname, lname, email, message }
      );

      // Subscribe to Mailchimp if checkbox is checked
      if (subscribe) {
        try {
          await subscribeToMailchimp(email, fname, lname);
        } catch (mcError) {
          // Don't fail the whole submission if Mailchimp fails
          console.warn('Mailchimp subscription failed:', mcError.message);
        }
      }

      setStatus('success');
      setFname('');
      setLname('');
      setEmail('');
      setMessage('');
      setSubscribe(false);
    } catch (error) {
      setErrorMessage(error?.text || error?.message || 'Please try again later');
      setStatus('error');
    }
  };

  return (
    <div className="page-wrapper">
      <div className="main-container contact-page">
        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>Contact</h2>

          {status === 'success' && (
            <p className="form-message success">Message sent successfully!</p>
          )}
          {status === 'error' && (
            <p className="form-message error">
              Failed to send message. {errorMessage && <span>({errorMessage})</span>}
            </p>
          )}

          <input
            type="text"
            placeholder="First Name"
            name="fname"
            className="contact-input"
            value={fname}
            onChange={(e) => setFname(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Last Name"
            name="lname"
            className="contact-input"
            value={lname}
            onChange={(e) => setLname(e.target.value)}
            required
          />
          <div className="flex column-gap email-subscribe-container">
            <input
              type="email"
              placeholder="Email"
              name="email"
              className="contact-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="flex">
              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  name="subscribe"
                  checked={subscribe}
                  onChange={(e) => setSubscribe(e.target.checked)}
                />
                <span className="checkbox-square"></span>
                sign up for my newsletter
              </label>
            </div>
          </div>
          <textarea
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <div className="contact-bttn-container">
            <button className="contact-bttn" type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending...' : 'Send'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Contact;
